import React from "react";
import useComponentVisible from "../UI/ComponentVisible";
import { useContentfulContext } from "../../contexts/ContentfulContext";

const DropdownButton = ({ handleSubmit }) => {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const { content } = useContentfulContext();

  const handleSelectButton = (action) => {
    handleSubmit(action);
  };

  return (
    <>
      <div className="inline-flex items-center relative">
        <div className="relative">
          <div ref={ref}>
            <div className="flex">
              <button
                type="button"
                onClick={() =>
                  handleSelectButton(
                    content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.update_contentful.id
                  )
                }
                className={`px-5 py-2.5 text-sm min-w-[120px] text-center text-white bg-primary hover:bg-primary-2 focus:ring-4 focus:outline-none font-medium rounded-s-lg`}
              >
                {content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.update_contentful.name}
              </button>
              <button
                className={`px-5 py-2.5 text-sm text-center text-white bg-primary hover:bg-primary-2 focus:ring-4 focus:outline-none font-medium rounded-e-lg border-l-2`}
                onClick={() => setIsComponentVisible(!isComponentVisible)}
              >
                <svg
                  className="w-2.5 h-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
            </div>
            {isComponentVisible && (
              <div className="bg-white divide-y divide-gray-100 rounded-lg shadow w-44 absolute top-full z-40 max-h-60 overflow-auto w-full">
                <ul
                  className="py-2 text-sm text-gray-700"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <a
                      onClick={() =>
                        handleSelectButton(
                          content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.save_experience.id
                        )
                      }
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      {content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.save_experience.name}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleSelectButton(
                          content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.activate_at.id
                        )
                      }
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      {content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.activate_at.name}
                    </a>
                  </li>
                  {/* hidden for now  */}
                  {/* <li>
                    <a
                      onClick={() => {
                        handleSelectButton(
                            content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.both.id
                        )
                      }}
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      {content.CONTENTFUL_ENTRY_DETAILS_CONTENT.dropdown_btn.both.name}
                    </a>
                  </li> */}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DropdownButton;
